import { useQuery } from "@tanstack/react-query";

import { searchSegmentEntities } from "services";

import { SEARCH_FEATBIT_SEGMENT_ENTITIES, SEGMENT_ENTITY_SEARCH_MIN_LENGTH } from "consts";
import type { SegmentUploadType } from "consts";

import { SegmentEntry } from "models";

// Only searches once the (already debounced) text is long enough, so typing does not flood the API.
export const useSearchSegmentEntities = (type: SegmentUploadType, query: string) =>
  useQuery<SegmentEntry[]>({
    queryKey: [SEARCH_FEATBIT_SEGMENT_ENTITIES, type, query],
    queryFn: () => searchSegmentEntities({ type, query }),
    enabled: query.trim().length >= SEGMENT_ENTITY_SEARCH_MIN_LENGTH,
    retry: false,
  });
